import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/views/Home'
import Robot from '@/views/Robot'
import RobotRefno from '@/views/RobotRefno'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/robot',
      name: 'Robot',
      component: Robot
    },
    {
      path: '/robot_refno',
      name: 'RobotRefno',
      component: RobotRefno
    },
    {
      path: '/billing',
      name: 'Billing',
      component: () => import('@/views/Billing.vue')
    },
    {
      path: '/success',
      name: 'Success',
      component: () => import('@/views/Success.vue')
    },
    {
      path: '/cash/indonesia/create',
      name: 'Indonesia',
      component: () => import('@/views/Indonesia.vue')
    },
    {
      path: '/cash/indonesia/pay',
      name: 'IndonesiaPay',
      component: () => import('@/views/IndonesiaPay.vue')
    },
    {
      path: '/cash/Thailand',
      name: 'Thailand',
      component: () => import('@/views/Thailand.vue')
    },
    {
      path: '/cash/Brazil',
      name: 'Brazil',
      component: () => import('@/views/Brazil.vue')
    },
    {
      path: '/cash/Php',
      name: 'Php',
      component: () => import('@/views/Php.vue')
    },
    {
      path: '/cash/Ngn',
      name: 'Ngn',
      component: () => import('@/views/NgnBank.vue')
    },
    {
      path: '/cash/thailand/create',
      name: 'Thai',
      component: () => import('@/views/CashThailand.vue')
    }, {
      path: '/cash/thailand/banks',
      name: 'Thai',
      component: () => import('@/views/ThailandBank.vue')
    }, {
      path: '/cash/transactionDetails',
      name: 'Thai',
      component: () => import('@/views/TransactionDetails.vue')
    }, {
      path: '/cash/php/create',
      name: 'Thai',
      component: () => import('@/views/CashPhp.vue')
    }, {
      path: '/cash/orderState',
      name: 'Thai',
      component: () => import('@/views/OrderState.vue')
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js